const CONSTANTS = {
  SET_REFRESHING_TOKEN: "SET_REFRESHING_TOKEN",
  SET_REFRESHING_TOKEN_FAILED: "SET_REFRESHING_TOKEN_FAILED",
  LOGIN_REQ: "LOGIN_REQ",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",
  LOGOUT_USER: "LOGOUT_USER",
  SET_SESSION: "SET_SESSION",
  SET_USER: "SET_USER",
  SET_LOADING: "SET_LOADING",
  REFRESH_SESSION: "REFRESH_SESSION",
  CHECK_SESSION: "CHECK_SESSION",
  RESET_ALL: "RESET_ALL",
  USER_MUST_CHANGE_PASSWORD: "USER_MUST_CHANGE_PASSWORD",
  CHANGE_USER_PASSWORD: "CHANGE_USER_PASSWORD",

  LS_SIDEBAR_OPEN: "sidebarOpen",
  LS_LOGGED_IN: "loggedIn",
  LS_USER_MUST_CHANGE_PASSWORD: "userMustChangePassword",

  GET_APPROVAL_EXPIRATION_STATUS: "GET_APPROVAL_EXPIRATION_STATUS",
  SET_APPROVAL_EXPIRATION_STATUS: "SET_APPROVAL_EXPIRATION_STATUS",

  CHECK_USER: "CHECK_USER",
  ACCEPTED_TERMS: "ACCEPTED_TERMS",

  GET_MAIN_LOGIN_SEND_OTP: "GET_MAIN_LOGIN_SEND_OTP",
  SET_MAIN_LOGIN_SEND_OTP: "SET_MAIN_LOGIN_SEND_OTP",

  GET_MAIN_CHECK_USER: "GET_MAIN_CHECK_USER",
  SET_MAIN_CHECK_USER: "SET_MAIN_CHECK_USER",

  GET_MAIN_REGISTER_USER: "GET_MAIN_REGISTER_USER",
  SET_MAIN_REGISTER_USER: "SET_MAIN_REGISTER_USER",

  GET_MAIN_LOGIN_WITH_CODE: "GET_MAIN_LOGIN_WITH_CODE",
  SET_MAIN_LOGIN_WITH_CODE: "SET_MAIN_LOGIN_WITH_CODE",

  GET_MAIN_VALIDATE_OTP: "GET_MAIN_VALIDATE_OTP",
  SET_MAIN_VALIDATE_OTP: "SET_MAIN_VALIDATE_OTP",

  GET_MAIN_RECOVER_PASSWORD: "GET_MAIN_RECOVER_PASSWORD",
  SET_MAIN_RECOVER_PASSWORD: "SET_MAIN_RECOVER_PASSWORD",

  GET_MAIN_START_IDENTOMAT: "GET_MAIN_START_IDENTOMAT",
  SET_MAIN_START_IDENTOMAT: "SET_MAIN_START_IDENTOMAT",

  GET_MAIN_VALIDATE_IDENTOMAT: "GET_MAIN_VALIDATE_IDENTOMAT",
  SET_MAIN_VALIDATE_IDENTOMAT: "SET_MAIN_VALIDATE_IDENTOMAT",

  GET_VALIDATE_INSURER:"GET_VALIDATE_INSURER",
  SET_VALIDATE_INSURER:"SET_VALIDATE_INSURER",

  GET_MAIN_SNED_OTP_TO_MOBILE: "GET_MAIN_SNED_OTP_TO_MOBILE",
  SET_MAIN_SNED_OTP_TO_MOBILE: "SET_MAIN_SNED_OTP_TO_MOBILE",

  GET_MAIN_CHANGE_MOBILE: "GET_MAIN_CHANGE_MOBILE",
  SET_MAIN_CHANGE_MOBILE: "SET_MAIN_CHANGE_MOBILE",

  SET_LOGIN_REQ: "SET_LOGIN_REQ",

  GET_MAIN_TO_IDENTOMAT: "GET_MAIN_TO_IDENTOMAT",
  SET_MAIN_TO_IDENTOMAT: "SET_MAIN_TO_IDENTOMAT",

};

export default CONSTANTS;
